// @flow

import {createMemoryHistory} from "history";

export const customHistory = createMemoryHistory();
